const categories = [
  { label: '古装传奇', icon: 'ri-sword-line', count: '328 部' },
  { label: '都市情感', icon: 'ri-heart-line', count: '256 部' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '189 部' },
  { label: '青春偶像', icon: 'ri-star-line', count: '142 部' },
  { label: '历史大剧', icon: 'ri-building-2-line', count: '115 部' },
  { label: '奇幻仙侠', icon: 'ri-magic-line', count: '97 部' },
  { label: '谍战军旅', icon: 'ri-shield-flash-line', count: '83 部' },
  { label: '家庭伦理', icon: 'ri-home-heart-line', count: '106 部' },
  { label: '韩剧热播', icon: 'ri-global-line', count: '174 部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">分类索引</h2>
          <p className="text-sm text-foreground-500">按类型快速找到你想看的电视剧</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.label}
              href="#cards"
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-background-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <div>
                <div className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {cat.label}
                </div>
                <div className="text-xs text-foreground-400">{cat.count}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}